import { render, staticRenderFns } from "./CompanyCallback.vue?vue&type=template&id=255ff474&scoped=true&"
import script from "./CompanyCallback.vue?vue&type=script&lang=js&"
export * from "./CompanyCallback.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCallback.vue?vue&type=style&index=0&id=255ff474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255ff474",
  null
  
)

export default component.exports